import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Profile } from 'src/app/assabil-kernel/models/entities/master-data/profile-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { ProfileLovComponent } from '../../profile/profile-lov/profile-lov.component';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';


@Component({
    selector: 'person-lov',
    templateUrl: './person-lov.component.html',
    styleUrls: ['./person-lov.component.scss']
})

export class PersonLovComponent extends GenericLovComponent    {
  
code    : string;
name    : string;
profile : Profile = new  Profile();

    
profileLovComponent = ProfileLovComponent;

persons            : Person[] = [];
    columns = [
    {  prop: 'personCode',  name: 'Code'},
    {  prop: 'name',        name: 'Name' 
    }
]

constructor(
    public dialogRef: MatDialogRef<PersonLovComponent>,
    protected masterDataService : MasterDataService,
    protected toastr: ToastrService,
    protected router: Router,
    protected location : Location) {
    super();
}
    

//--------------------------------------------------------------------------------------------------------------------   
loadData() {
    this.masterDataService.personsGet(this.code, this.name, this.profile.profileCode).then(result => {
        this.persons = result;
    })
}
//--------------------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------------------
closeModal(row : Profile){
    this.dialogRef.close(row);
}
//--------------------------------------------------------------------------------------------------------------------

}
